import React, { FormEvent, useState } from "react";
import { Col, Form, FormGroup, Input, Label, Spinner } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { Btn, H2, P } from "../AbstractElements";
import { EmailAddress, Password, SignIn } from "../Utils/Constants";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../ReduxToolkit/Reducers/auth";
import { AppDispatch, RootState } from "../ReduxToolkit/Store";
import { getFirstPermissionRoute } from "../Data/Layout/SidebarMenuList";

export default function SignInForm() {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { isLoading } = useSelector((state: RootState) => state.auth);
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const toggle = () => setPasswordVisible(!isPasswordVisible);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    const result = await dispatch(login(email, password));

    if (result?.statusCode === 200) {
      const firstRoute = getFirstPermissionRoute(result.data?.permissions);
      navigate(firstRoute);
    }
  };
  return (
    <div>
      <div className="login-main">
        <Form className="theme-form" onSubmit={handleSubmit}>
          <H2 className="text-center">Sign In</H2>
          <P className="text-center">
            {"Enter your email & password to login"}
          </P>
          <FormGroup>
            <Col>
              <Label>{EmailAddress}</Label>
            </Col>
            <Input
              type="email"
              defaultValue={email}
              placeholder="Enter Email"
              onChange={(event) => setEmail(event.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <Col>
              <Label>{Password}</Label>
            </Col>
            <div className="form-input position-relative">
              <Input
                type={isPasswordVisible ? "text" : "password"}
                placeholder="Enter Password"
                defaultValue={password}
                onChange={(event) => setPassword(event.target.value)}
                name="login[password]"
              />
              <div className="show-hide" onClick={toggle}>
                <span className={!isPasswordVisible ? "show" : ""}></span>
              </div>
            </div>
          </FormGroup>
          <FormGroup className="mb-0 checkbox-checked">
            {/* <FormGroup className="checkbox-solid-info" check>
                            <Input id="checkbox1" type="checkbox" />
                            <Label htmlFor="checkbox1" check>{RememberPassword}</Label>
                        </FormGroup> */}
            {/* <Link className="link" to={`/authentication/forget_password`}>{ForgotPassword}</Link> */}
            <div className="text-end mt-3">
              <Btn color="primary" className="w-100" block disabled={isLoading}>
                {isLoading ? <Spinner size="sm" /> : SignIn}
              </Btn>
            </div>
          </FormGroup>
          {/* <div className="login-social-title"><H6>{SignInWith}</H6></div>
                    <SocialLink />
                    <P className="mt-4 mb-0 text-center">{DontHaveAccount}
                        <Link className="ms-2" to={`/authentication/register_simple`}>{CreateAccount}</Link>
                    </P> */}
        </Form>
      </div>
    </div>
  );
}
